import { createMemo, Show, type JSX } from 'solid-js'

import Css from './charts.module.scss'

/**
 * A mini-serie ao lado de um numero.
 *
 * Sem eixo, sem grade e sem balao de proposito: o que ela diz e a FORMA - se a
 * medida subiu ou desceu no periodo. O numero exato esta ao lado dela.
 */
export function Spark(props: { values: readonly number[] }): JSX.Element {
    const path = createMemo(() => {
        const values = props.values
        if (values.length < 2) {
            return undefined
        }

        const min = Math.min(...values)
        const max = Math.max(...values)
        const span = max - min || 1

        const line = values
            .map((value, index) => {
                const x = (index / (values.length - 1)) * 100
                const y = 28 - ((value - min) / span) * 24
                return `${index === 0 ? 'M' : 'L'} ${x.toFixed(2)} ${y.toFixed(2)}`
            })
            .join(' ')

        return { line, area: `${line} L 100 32 L 0 32 Z` }
    })

    return (
        <Show when={path()}>
            {(shape) => (
                <svg viewBox="0 0 100 32" preserveAspectRatio="none" class={Css.sparkline} aria-hidden="true">
                    <defs>
                        <linearGradient id="spark-fill" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stop-color="var(--accent)" stop-opacity="0.25" />
                            <stop offset="100%" stop-color="var(--accent)" stop-opacity="0" />
                        </linearGradient>
                    </defs>
                    <path d={shape().area} fill="url(#spark-fill)" />
                    <path
                        d={shape().line}
                        fill="none"
                        stroke="var(--accent)"
                        stroke-width="2"
                        vector-effect="non-scaling-stroke"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            )}
        </Show>
    )
}
